import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "pr-3" }
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_5 = { style: {"white-space":"pre-wrap"} }

import {LineInterface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/log/Interface";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {ref} from "vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DataProviderLogLine"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    line: {},
    expandedAvailableToDisplay: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

let showExpanded = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(ElCardSection, { class: "line" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.line.type)
            ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                key: 0,
                icon: __props.line.type.icon,
                color: typeof __props.line.isSuccess == 'boolean' ? (__props.line.isSuccess ? 'success' : 'danger') : 'muted'
              }, null, 8, ["icon", "color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(__props.line.text) + " ", 1),
          (__props.line.expandedInfo && __props.expandedAvailableToDisplay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_el_button, {
                  link: "",
                  class: "p-0 h-auto",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showExpanded) //@ts-ignore
 ? showExpanded.value = true : showExpanded = true))
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Подробности ", -1)
                  ]))]),
                  _: 1
                }),
                (_unref(showExpanded))
                  ? (_openBlock(), _createBlock(_component_el_dialog, {
                      key: 0,
                      modelValue: _unref(showExpanded),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showExpanded) ? (showExpanded).value = $event : showExpanded = $event)),
                      title: "Подробности"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("pre", _hoisted_5, _toDisplayString(__props.line.expandedInfo), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})